/**
 * ETMF Overview Page - Main Entry Point
 *
 * Migrated from: lego/page/etmf/overview/Page.jsx
 *
 * This is the main wrapper component for the ETMF Overview page.
 * It provides the service context and event bus infrastructure.
 */

import { useRef } from 'react'
import { EventBus } from 'ts-bus'
import { Formik } from 'formik'
import { ThemeProvider } from '@mdsol/onex-design'
import Status from './Status'
import ActionsMenuWrapper from './ActionsMenuWrapper'
import Summary from './Summary'
import { useTranslation } from 'react-i18next'

interface PageEtmfStatusProps {
  [key: string]: any
}

const PageEtmfStatus: React.FC<PageEtmfStatusProps> = (props) => {
  const eventBus = useRef(new EventBus())
  const store = useRef<Record<string, any>>({})
  const ref = useRef<HTMLDivElement>(null)
  const isSummaryScreen = useRef<any>(true)
  const { t } = useTranslation()

  return isSummaryScreen ? (
    <>
      <ThemeProvider>
        <Summary />
      </ThemeProvider>
    </>
  ) : (
    <div className="mcc-content-frame theme-sandman">
      <div className="etmf-overview-page-wrapper" ref={ref}>
        <div className="overview-page-wrapper">
          <div className="page-header d-flex justify-content-between mt0">
            <h2>{t('ETMF_STATUS_TITLE')}</h2>
            <div className="etmf-overview-action-menu" style={{ position: 'static' }}>
              <ActionsMenuWrapper />
            </div>
          </div>
          <Formik initialValues={{}} onSubmit={() => {}}>
            {() => <Status />}
          </Formik>
        </div>
      </div>
    </div>
  )
}

export default PageEtmfStatus
